import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { VigenciaParametroShow } from '../../components'
import * as vigenciaParametroActionCreators from '../../redux/modules/vigenciaParametro'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'

class VigenciaParametroShowContainer extends Component {

  static propTypes = {
    instalacao: PropTypes.object.isRequired,

    id: PropTypes.string,
    history: PropTypes.object,
    fetchVigenciaParametro: PropTypes.func,
    destroyVigenciaParametro: PropTypes.func,
    isLoading: PropTypes.bool,

    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
  }

  state = {
    vigenciaParametro: null
  }

  async componentDidMount () {
    if (this.props.id) {
      const vigenciaParametro = await this.props.fetchVigenciaParametro(this.props.id)
      this.setState({ vigenciaParametro })
    }
  }

  handleEditResource = (instalacaoId, id) => {
    this.props.history.push(`/instalacoes/${instalacaoId}/parametros/${id}/edit`)
  }

  handleDeleteResource = async (instalacaoId, id) => {
    if (await this.props.destroyVigenciaParametro(id)) {
      this.props.showSuccessfulFlashMessage('', 'destroy')
      this.props.history.push(`/instalacoes/${instalacaoId}/parametros`)
    } else {
      this.props.showErrorFlashMessage('', 'destroy', this.props.error)
    }
  }

  render () {
    return (
      <VigenciaParametroShow
        isLoading={this.props.isLoading}
        instalacao={this.props.instalacao}
        onEditResource={() => this.handleEditResource(this.props.instalacao.id, this.state.vigenciaParametro.id)}
        onDeleteResource={() => this.handleDeleteResource(this.props.instalacao.id, this.state.vigenciaParametro.id)}
        vigenciaParametro={this.state.vigenciaParametro} />
    )
  }
}

function mapStateToProps ({vigenciaParametro, status}, {match}) {
  const { id } = match.params
  const isLoading = status.getIn(['vigenciaParametro', 'isLoading'])
  if (id) {
    return {
      id,
      vigenciaParametro: vigenciaParametro.get('id'),
      isLoading,
    }
  }
  return {
    isLoading,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...vigenciaParametroActionCreators,
    ...flashMessageActionCreators
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VigenciaParametroShowContainer))
